var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.list)?_c('bv-tab-bar',{attrs:{"list":_vm.list,"active-class-name":'bc-t-base',"active-index":_vm.activeIndex}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }